import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MainLayoutComponent } from './MainLayoutComponent';
import { SharedModule } from 'src/app/shared/SharedModule';

@NgModule({
  imports: [
    SharedModule,
    RouterModule
  ],
  declarations: [
    MainLayoutComponent
  ]
})
export class MainLayoutModule {
}

